export default "__VITE_ASSET__OKd1vqr4__"